/**
*
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<router-view />
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>{{Name}}</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card style="margin-top: 20px;">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="搜索：">
					<el-select v-model="formInline.BIllName" clearable filterable placeholder="请选择过滤条件 "
						style="display: block;height: 90%;" size="small">
						<el-option v-for="item in tableLabel" :key="item.item" :value-key="item.item" :label="item.label"
							:value="item.item">
							<span style="float: left; color: #8492a6; font-size: 17px">{{
				                  item.label
				                }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input size="small" v-model="formInline.deptName" placeholder="过滤值"></el-input>
				</el-form-item>
				<el-form-item>
				 <el-date-picker
					v-model="value2"
					type="daterange"
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
					value-format="yyyy-MM-dd">
					</el-date-picker>
					</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
					<el-button size="small" type="primary" icon="el-icon-search" @click="insertd()">新增</el-button>
					<el-button size="small" type="primary" icon="el-icon-search" @click="Dinster()">导入</el-button>
					<el-button size="small" type="primary" icon="el-icon-search" @click="Dout()">导出</el-button>
				</el-form-item>
				<el-form-item style="float:right">
				  <span>{{tert}}</span>
				</el-form-item>
			</el-form>
		</el-card>
		<!--列表-->
			<el-card >
			<el-button-group class="pull-left m-l-sm">
				<el-button v-for="(item, index) in btnArraylinx" :key="item.LItemID"
					:class="{ active: currentSorts == index }" @click="giveCharData(index)" size="small"
					style="font-size: 14px;">
					{{ item.LName }}
				</el-button>
			</el-button-group>

		</el-card>
		<el-card style="margin-top: 10px;">
			<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="全部展示"  name="first"></el-tab-pane>
			<el-tab-pane label="充值" name="second"></el-tab-pane>
			<el-tab-pane label="消费" name="third"></el-tab-pane>
			</el-tabs>
			<el-table ref="multipleTable" :data="listinData.slice((currentPage - 1) * pagesize, currentPage * pagesize)" border id="out-table" v-loading="loading" class="demo-Form" :highlight-current-row="false"
				 element-loading-text="拼命加载中" style="width: 100%;"
				@selection-change="handleSelectionChange"
				:header-cell-style="{'text-align':'center'}" >
				<el-table-column align="center" sortable prop="LNo" label="序号" width="120">
						<template slot-scope="scope">
						<span>
							{{scope.$index+1}}
						</span>
					</template>
				</el-table-column>
				<el-table-column align="center" sortable prop="LDate" label="时间">
				</el-table-column>
				<el-table-column align="center" sortable prop="username" label="客户" >
				</el-table-column>
					<el-table-column align="center" sortable prop="LPhone" label="客户电话" >
				</el-table-column>
				<el-table-column align="center" sortable prop="LCount" label="积分" >
				</el-table-column>
				<el-table-column align="center" sortable prop="LType" label="类型" >
				</el-table-column>
				<el-table-column align="center" sortable prop="LRemark" label="备注">
				</el-table-column>
					<el-table-column align="center"  prop="contuil" label="操作">
					<template slot-scope="scope">
					 <!-- <el-button type="text" size="small" @click="spearchange(scope.row)">修改</el-button> -->
					 <el-button type="text"  size="small" @click="spear(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="listinData.length">
				</el-pagination>
			</div>
		</el-card>
			 <el-dialog :title="title" :visible.sync="editFormVisible" width="30%">
      <el-form label-width="80px" ref="editForm" :model="editForm" >
		<el-form-item label="客户名称" prop="KHName">
          <el-select size="small" v-model="editForm.KHName" filterable placeholder="请选择" class="userRole">
           	<el-option v-for="item in ModelTable"  :key="item.LItemID" :value-key="item.LItemID" :label="item.LName"
			:value="item.LItemID">
			<span style="float: left; color: #8492a6; font-size: 17px">{{
					item.LName
				}}</span>
				<span style="float: right; color: #8492a6; font-size: 17px">{{
					item.LPhone
				}}</span>
				</el-option>
			</el-select>
        </el-form-item>
		<el-form-item label="时间" prop="LMone">
         <el-date-picker
			v-model="editForm.date"
			type="date"
			value-format="yyyy-MM-dd"
			placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
		<el-form-item>
		<el-radio-group v-model="editForm.radio">
			<el-radio :label="1">充值</el-radio>
			<el-radio :label="2">消费</el-radio>
		</el-radio-group>
		</el-form-item>
        <el-form-item label="产品名称" prop="CPName" v-if="editForm.radio==2">
          <el-select size="small" v-model="editForm.CPName" filterable  multiple   placeholder="请选择" class="userRole" @change="cpo">
           	<el-option v-for="item in CPtable" :key="item.LItemID" :value-key="item.LItemID" :label="item.LName"
			:value="item.LItemID">
			<span style="float: left; color: #8492a6; font-size: 17px">{{
					item.LName
				}}</span>
		</el-option>
		     </el-select>
        </el-form-item>
        <!-- <el-form-item label="产品型号" prop="modeId" v-if="editForm.radio==2">
        <el-input  size="small" v-model="editForm.modeId"></el-input>
        </el-form-item>
		 <el-form-item label="产品货值" prop="Mone" v-if="editForm.radio==2">
        <el-input  size="small" v-model="editForm.Mone"></el-input>
        </el-form-item> -->
        <el-form-item label="积分" prop="LMone">
          <el-input type="number" size="small" v-model="editForm.LMone"></el-input>
        </el-form-item>
		<el-form-item label="备注" prop="LRemark">
          <el-input size="small" v-model="editForm.LRemark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small"  @click="flase() ">取消</el-button>
        <el-button size="small" type="primary"  @click="submitForm('editForm')">保存</el-button>
      </div>
	</el-dialog>
	</div>
</template>
<script>
	import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		OperateBill
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	import axios from 'axios';
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	import {exportExcel} from '../../utils/index.js'
	export default {
		data() {
			return {
				radio:'1',
				centerDialogVisible: false,
				v_str_AccountID: '165',
				nshow: true, //switch开启
				fshow: false, //switch关闭
				loading: false, //是显示加载
				load: false,
				editFormVisible: false, //控制编辑页面显示与隐藏
				//upselect: false,
				title: '添加',
				activeName: 'first',
				listinData: [],
				readonly: true,
				CPtable: [],
				ModelTable: [],
				editForm: {
					KHName: '',
                    date: '',
					CPName: '',
					modeId: '',
					LMone: '',
					LRemark: '',
					radio:1,
					Mone:'',
					token: localStorage.getItem('logintoken')
				},
				btnArraylinx: [{
					LItemID: '0',
					LName: '一周内',
					LCode: '0'
				}, {
					LItemID: '1',
					LName: '一月内',
					LCode: '1'
				}, {
					LItemID: '2',
					LName: '一年内',
					LCode: '2'
				}, {
					LItemID: '3',
					LName: '全部',
					LCode: '3'
				}],
				dialogFormVisible: false,
				dailogTitleType1: '目标单据',
				currentPage: 1, //默认显示第一页
				pagesize: 5, //默认每页显示10条
				totalNum: 0, //总页数
				tableLabel:[{
				 item:'客户名称',
				 label:'客户名称'
				},{
				 item:'客户电话',
				 label:'客户电话'
				}],
				dept: [],
				needMergeArr: ['L_BillNo','L_BatchNo','jindu','contuil'],
				rowMergeArrs: [],
				upnext: '',
				formInline: {
					page: 1,
					limit: 10,
					varLable: '',
					varName: '',
					BIllName:'客户名称',
					deptName:'',
					token: localStorage.getItem('logintoken'),
					data: [
						[{}]
					]
				},
				SysId: '',
				billNO: '',
				multipleSelection: [],
                Name: '',
				currentSort: "0",
				currentSorts: "0",
				tert:"",
				 pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
						}
					}]
					},
				value2: '',
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */
		/**
		 * 创建完毕
		 */
		watch: {
			'$route'(to, from) {
				this.$router.go(0);
				//  console.log(to)
			}
		},
		created() {
          this.getdata()
		},
		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {
			Dout(){
        this.src='https://rifengczyxzx.com/dist/index2.html';
					const loading = this.$loading({
					lock: true,
					text: '正在梳理数据',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
					});
				let Hdata=[]
				let nowdate=this.nowdate();
				let lastweekdate;
				if(this.currentSorts==0){
					lastweekdate=this.lastweekdate(7);
				}else if(this.currentSorts==1){
					lastweekdate=this.lastweekdate(30);
				}else if(this.currentSorts==1){
					lastweekdate=this.lastweekdate(365);
				}else{
					lastweekdate="1999-01-01";
				}
				if(this.value2){
					lastweekdate=this.value2[0]
					nowdate=this.value2[1]
				}
				let  modata = {
				'v_str_AccountID': this.v_str_AccountID,
				'jsSQL': "{\"SQL\":[{\"SELECT\":\"select  sum(LCount) as LCount,count(*) as count ,LType ,username,LPhone,LRemark from  v_INout where username like '%"+this.formInline.deptName+"%' and  LDate>='"+lastweekdate+"' and LDate<='"+nowdate+"' group by LType,username,LPhone,LRemark;   \"}]}"
				}
				login(modata).then(rem=>{
					let arr=rem.Data.Table;
					arr.forEach(item=>{
						if(item.LType=="充值"){
               // 检查备注是否包含"补"或"合并"
              const shouldExclude = item.LRemark && (item.LRemark.includes('补') || item.LRemark.includes('合并'));
              if(!shouldExclude) {
                item["LCountIn"]=item.count
              } else {
                item["LCountIn"]=0
              }
              item["TypeIn"]=item.LCount
              item["TypeOut"]=0
              item["LCountOut"]=0
							// item["TypeIn"]=item.LCount
							// item["LCountIn"]=item.count
							// item["TypeOut"]=0
							// item["LCountOut"]=0
						}else{
							item["TypeOut"]=item.LCount
							item["LCountOut"]=0
							item["TypeIn"]=0
							item["LCountIn"]=0
						}
					})

					const fields = ['username', 'LPhone'];
					// 根据多个字段合并
					// const mergedArr = arr.reduce((acc, cur) => {
					// const key = fields.map(field => cur[field]).join('_');
					// const existItem = acc.find(item => item.key === key);
					// if (existItem) {
					// 	existItem.data.push(cur);
					// } else {
					// 	acc.push({
					// 	key,
					// 	data: [cur]
					// 	});
					// }
					// return acc;
					// }, []).map(item => item.data);
          const mergedData = arr.reduce((acc, cur) => {
         const key = `${cur.username}_${cur.LPhone}`;

        if (!acc[key]) {
          // 创建新记录
          acc[key] = {
            username: cur.username,
            LPhone: cur.LPhone,
            TypeIn: cur.TypeIn,
            LCountIn: cur.LCountIn,
            TypeOut: cur.TypeOut,
            LCountOut: cur.LCountOut
          };
        } else {
          // 合并记录，合计值
          acc[key].TypeIn += cur.TypeIn;
          acc[key].LCountIn += cur.LCountIn;
          acc[key].TypeOut += cur.TypeOut;
          acc[key].LCountOut += cur.LCountOut;
        }

        return acc;
      }, {});
          // for(let i=0;i<mergedArr.length;i++){
          //   let item=mergedArr[i]
          //   if(item.length>1){
					// 		item[0].TypeOut=item[1].TypeOut
					// 		item[0].LCountOut=item[1].LCountOut
					// 		let po=item[0]
					// 		po["Typeall"]=item[0].TypeIn-item[0].TypeOut
					// 		po["LCountall"]=item[0].LCountIn-item[0].LCountOut
					// 		Hdata.push(po)
					// 	}else{
					// 	  let po=item[0]
					// 	  po["Typeall"]=item[0].TypeIn-item[0].TypeOut
					// 	  po["LCountall"]=item[0].LCountIn-item[0].TypeOut
          //     Hdata.push(po)
					// 	}
          // }
					// // mergedArr.forEach(item=>{

					// // })
          let Hdata = Object.values(mergedData).map(item => {
            item.Typeall = item.TypeIn - item.TypeOut;
            item.LCountall = item.LCountIn - item.LCountOut;
            return item;
          });
          console.log(Hdata);
					window.localStorage.setItem('LName',JSON.stringify(Hdata));
				  window.open(this.src, "_blank");
					loading.close();

				})


			},
			export(){
				console.log(this.listinData)
				exportExcel(this.$refs.multipleTable, "工具积分", "工具积分.xlsx").then(()=>{
	            this.currentPage=1;
				this.pagesize=5;
				});
			},
			flase(){
				this.editFormVisible=false
			},
			insertd(){
			  this.editForm.modeId="";
			  this.editForm.LMone="";
			  this.editForm.Mone="";
			  this.editForm.KHName="";
			  let phemss = {
				'v_str_AccountID': this.v_str_AccountID,
				'jsSQL': "{\"SQL\":[{\"select\":\" select  * from A_Kh ;select  * from V_CP \"}]}"
		    	}
			 login(phemss).then(res => {
			  let arr=res.Data.Table;
			  let arr1=res.Data.Table1;
        this.ModelTable =arr
        this.CPtable =arr1
			})
			  this.editForm.date=this.formatDate(new Date());
             this.editFormVisible=true
			},
			findObjectById(arr, targetId) {
				return arr.find((obj) => obj.LItemID === targetId);
			},
			formatDate(date) {
				const year = date.getFullYear();
				const month = ('0' + (date.getMonth() + 1)).slice(-2);
				const day = ('0' + date.getDate()).slice(-2);
				return `${year}-${month}-${day}`;
			},
			cpo(){
			//   let mm=this.findObjectById(this.CPtable ,this.editForm.CPName);
			//   this.editForm.modeId=mm.LModel;
			//   this.editForm.LMone=mm.LCount;
			//   this.editForm.Mone=mm.LMone
			// 	console.log(mm)
			},
			submitForm(){
				console.log(this.editForm.CPName)
				if(this.editForm.radio==1){
					let phemss = {
				'v_str_AccountID': this.v_str_AccountID,
				'jsSQL': "{\"SQL\":[{\"insert\":\"insert into A_INOUT(LUserID,LCPID,LCount,LType,LRemark,LDate)values ('"+this.editForm.KHName+"','"+this.editForm.CPName+"','"+this.editForm.LMone+"','"+this.editForm.radio+"','"+this.editForm.LRemark+"','"+this.editForm.date+"')\"}]}"
				}
				login(phemss).then(res => {
					if(res.Result=="Y"){
						this.$message({
							type: 'sucess',
							message: "成功"
						});
			 	}else{
					this.$message({
							type: 'error',
							message: "失败"
						});
		       }
			})
			}else{
				let phe={
					'v_str_AccountID': this.v_str_AccountID,
				'jsSQL': "{\"SQL\":[{\"insert\":\"select sum(LCount) as LCount,LType from A_INOUT where LUserID='"+this.editForm.KHName+"' group by LType  \"}]}"
				}

				login(phe).then(res =>{
				   let arr=res.Data.Table;
				   let Outin, Inout
				    Inout= arr.find((element) => {
					return element.LType == 1;
					});
					 Outin= arr.find((element) => {
					return element.LType == 2;
					});
					if(Outin){}else{Outin=[];Outin['LCount']=0}
					if(Inout){}else{Inout=[];Inout['LCount']=0}
				   if(Inout.LCount >= (Number( Outin.LCount)+ Number(this.editForm.LMone))){
					   	for(let i=0;i<this.editForm.CPName.length;i++){
							   let LMone;
							   if(i==0){
								   LMone=this.editForm.LMone
							   }else{
								   LMone=0
							   }
						 let phemss = {
								'v_str_AccountID': this.v_str_AccountID,
								'jsSQL': "{\"SQL\":[{\"insert\":\"insert into A_INOUT(LUserID,LCPID,LCount,LType,LRemark,LDate)values ('"+this.editForm.KHName+"','"+this.editForm.CPName[i]+"','"+LMone+"','"+this.editForm.radio+"','"+this.editForm.LRemark+"','"+this.editForm.date+"')\"}]}"
								}
						login(phemss).then(res => {
							if(res.Result=="Y"){
								if(i==this.editForm.CPName.length-1){
									this.$message({
									type: 'sucess',
									message: "成功"
								});
							}
							}else{
							  this.$message({
									type: 'error',
									message: "失败"
								});
							   }
						})
					}
				   }else{
					   	this.$message({
							type: 'error',
							message: "当前积分小于产品积分，不可兑换"
						});
				   }
				})
			}
			this.getdata();
			this.editFormVisible=false
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				let litdata=this.listinData.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleRowClick(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			spear(row){
					this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
							let phemss = {
							'v_str_AccountID': this.v_str_AccountID,
							'jsSQL': "{\"SQL\":[{\"delete\":\"delete  from A_InOut where LItemID='"+row.LItemID+"'\"}]}"
						}
						 login(phemss).then(res => {
								if(res.Result=='Y'){
									this.$message({
								type: 'succes',
								message: '删除成功'
							});
             	}else{
					that.$message({
							type: 'error',
							message: '删除失败，请检查'
						});
						 }
						})
				  this.getdata()
					}).catch(() => {
					  this.$message({
						type: 'info',
						message: '已取消删除'
					  });
					});

			},
			nowdate(){
				var  date =  new  Date();
				var  year = date.getFullYear();
				var  month = date.getMonth() + 1;
				var  day = date.getDate();
				var  hour = date.getHours();
				var  minute = date.getMinutes();
				var  second = date.getSeconds();
				let  nowdate=year +  '-'  + month +  '-'  + day  +  ' '  + hour +  ':'  + minute +  ':'  + second;
				return nowdate
			},
			lastweekdate(mo){
			var  now =  new  Date();
			var  date =  new  Date(now.getTime() - mo * 24 * 3600 * 1000);
			var  year = date.getFullYear();
			var  month = date.getMonth() + 1;
			var  day = date.getDate();
			var  hour = date.getHours();
			var  minute = date.getMinutes();
			var  second = date.getSeconds();
			let  lastweekdate=year +  '-'  + month +  '-'  + day  +  ' '  + hour +  ':'  + minute +  ':'  + second;
			return lastweekdate
			},
			handleClick(tab, event) {
			  this.getdata();
			},
			getdata(){
				console.log(this.value2)
		     this.login=true
			 let nowdate=this.nowdate();
			 let lastweekdate;
			 if(this.currentSorts==0){
                  lastweekdate=this.lastweekdate(7);
			 }else if(this.currentSorts==1){
                lastweekdate=this.lastweekdate(30);
			 }else if(this.currentSorts==1){
                lastweekdate=this.lastweekdate(365);
			 }else{
				 lastweekdate="1999-01-01";
			 }
			 if(this.value2){
				 lastweekdate=this.value2[0]
				 nowdate=this.value2[1]
			 }
			 let type;
			 if(this.activeName=="first"){
                     type="1=1"
			 }else if(this.activeName=="second"){
                     type="Type=1"
			 }else {
                     type="Type=2"
			 }
			 let dat="";
			  if(this.formInline.BIllName=='客户名称'){
					dat='username'
				}else if(this.formInline.BIllName=='客户电话'){
					dat='LPhone'
				}
				if(this.formInline.deptName!=''){
					dat=dat+" like '%"+this.formInline.deptName+"%'"
					let  modata = {
						'v_str_AccountID': this.v_str_AccountID,
						'jsSQL': "{\"SQL\":[{\"SELECT\":\"select  sum(LCount) as LCount,LType from  v_INout where username='"+this.formInline.deptName+"' group by LType; select  sum(LCount) as LCount,LType from  v_WL where username='"+this.formInline.deptName+"' group by LType  \"}]}"
						}
					 	login(modata).then(rem=>{
							let arr=rem.Data.Table;
							let arr1=rem.Data.Table1;
							let inout=0,outin=0;
							let inouh=0,outinh=0;
							if(arr.length>0){
								arr.forEach(items=>{
								if(items.LType=="充值"){
								inout=items.LCount
								}else{
								outin=items.LCount
								}
							})
							}
							if(arr1.length>0){
								arr1.forEach(items=>{
								if(items.LType=="充值"){
								inouh=items.LCount
								}else{
								outinh=items.LCount
								}
							})
							}
						  this.tert="当前用户可用积分"+(Number(inout)-Number(outin))+",可用货值"+(Number(inouh)-Number(outinh))
						})


				}else{
					dat='1=1'
				}
             let phemss = {
				'v_str_AccountID': this.v_str_AccountID,
				'jsSQL': "{\"SQL\":[{\"select\":\" select  * from v_INout where "+dat+" and  "+type+" and  LDate>='"+lastweekdate+"' and LDate<='"+nowdate+"' order by LItemID desc \"}]}"
		    	}
			 login(phemss).then(res => {
			  let arr=res.Data.Table
			  arr.map(row => {
					row.LDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(row.LDate).toString();
					return row.LDate;
				});

              this.listinData=arr
              this.login=false
			})
           },
           giveCharData(index) {
				if (this.currentSorts === index) {
					return false;
				}
				this.currentSorts = index;
				this.getdata();
			},
			mergeAction(val, rowIndex) {
			    let _row = this.rowMergeArrs[val].rowArr[rowIndex];
			    let _col = _row > 0 ? 1 : 0;
			    return [_row, _col];
			},
			async search(){
				this.currentPage=1
					this.getdata()
				},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			    for(let res in this.needMergeArr){
			        if(this.needMergeArr[res] == column.property){
			            return this.mergeAction(column.property, rowIndex, columnIndex);
			        }
			    }
			},
			seedefor() {
				this.centerDialogVisible = true
			},
			async getPath(plant) {

			},
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}
 .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
	.userRole {
		width: 100%;
	}

	.active {
		background: #409eff;
		color: #fff;
	}

	.demo-ruleForm>>>.el-input__inner {
		border: 0;
		background-color:
			#FFF;
		color: #606266;
		/*text-align: center;*/
	}

	.demo-Form>>>.el-table__body tr:hover>td.el-table__cell {
		background-color: #FFF !important;
	}

	.demo-Form>>>.el-table__cell {
		padding: 5px;

	}

	.demo-ruleForm>>>.el-icon-arrow-up:before {
		content: '' !important;
	}

	.demo-ruleForm>>>.el-card__body {
		padding-top: 0px;
	}

	.demo-ruleForm>>>.el-table__body-wrapper {
		height: calc(100% - 70px) !important;
	}

	/deep/.el-popper[x-placement^=bottom] .popper__arrow::after {
		border-bottom-color: transparent;
	}

	/deep/.el-popper .popper__arrow,
	.el-popper .popper__arrow::after {
		border-style: none !important;
	}

	/deep/.el-table__footer-wrapper tbody td.el-table__cell {
		font-size: 1px;
	}

	/deep/.el-table .el-table__footer-wrapper .cell {
		font-size: 1px;
	}
</style>



// WEBPACK FOOTER //
// src/views/machine/Machine.vue